<template lang="pug">
  v-dialog(
    v-model="openCentroDeDescargas"
    @click:outside="openPopup"
    max-width="450", max-height="calc(100vh - 150px)"
    origin="top right"
    offset-y
    transition="slide-y-transition"
  )
    template(v-slot:activator='{ on, attrs }')
      v-badge(
        color='success'
        :offset-x="countDescargas ? 26 : -15"
        :offset-y="countDescargas ? 22 : -15"
        :content="countDescargas"
        bordered
        overlap
      )
        v-btn.mx-1( icon  depressed='' @click="openPopup()")
          v-icon(size="28") cloud_download
    v-card(max-width="450", max-height="calc(100vh - 150px)"  )
      .pa-4
        strong Procesos pendientes
      procesos-handler(v-if="showProcesos")
      .d-flex.fd-column.jc-center.ai-center.pa-8(v-else)
        v-icon(color="background", size="100") clear_all
        span.font-weight-700.primary--text
          | Ningún proceso en curso
        span.text-muted.font-size-12 No se encontraron procesos disponibles para mostrar
</template>
<script>
import procesosHandler from './c_procesos_handler.vue'
export default {
  components : {
    'procesos-handler' : procesosHandler
  },
  data  () {
    return {
    }
  },
  computed : {
    isMovil () {
      var vm = this
      return vm.$vuetify.breakpoint.smAndDown
    },
    showProcesos () {
      var vm = this
      return vm.$store.state.app.showProcesos
    },
    openCentroDeDescargas () {
      var vm = this
      return vm.$store.state.app.openPopupNotifications
    },
    countDescargas () {
      var vm = this
      return vm.$store.state.app.countAllDownloands
    }
  },
  methods : {
    openPopup () {
      var vm = this
      vm.$store.dispatch('setOpenPopupNotifications', !vm.openCentroDeDescargas)
    }
  }
}
</script>
<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// c_descargas_procesos_app.vue?9891fd08